import { createFileRoute, redirect } from '@tanstack/react-router';
import { getDefaultTargetMonth } from '@/features/contract-and-cost/targetMonth';
export const Route = createFileRoute('/_staff/device-catalog/active/$id/_layout/contract-and-cost/_contract-and-cost/cost/')({
  beforeLoad: ({
    params
  }) => {
    throw redirect({
      to: '/device-catalog/active/$id/contract-and-cost/cost/$targetMonth',
      params: {
        id: params.id,
        targetMonth: getDefaultTargetMonth()
      }
    });
  }
});